import {utils} from 'mc/lib';
import {DetailReducer} from 'mc/lib/detail';
import {SimpleListReducer} from 'mc/lib/list';
import {FeatureEditorReducer} from 'mc/lib/mapio';
import {SharedReducer} from 'mc/lib/shared';

const initialState = {
    applications: SimpleListReducer(),
    zadostList: SimpleListReducer(),
    typZaborList: SimpleListReducer(),
    lokalitaFeatureEditor: FeatureEditorReducer.fromValues({topic: 'zukp:zadost:editor'}),
    zadostZakresFeatureEditor: FeatureEditorReducer.fromValues({topic: 'zukp:zadost:editor'}),
    zadostShrnutiFeatureEditor: FeatureEditorReducer.fromValues({topic: 'zukp:zadost:souhrn'}),
    currentZadost: DetailReducer(),
    user: DetailReducer(),
    shared: SharedReducer()
};

export default function appReducer(state = initialState, action = {}) {
    if (action.area) {
        return utils.processAreaStores(state, action);
    }
    return state;
}
